export default [
    {
        // [0]
        key: "full_name",
        label: "full name",
        visible: true,
    },
    {
        // [1]
        key: "email",
        label: "email",
        visible: true,
    },
    {
        // [2]
        key: "type",
        label: "type",
        visible: true,
    },
    {
        // [3]
        key: "role",
        label: "role",
        visible: true,
    },
    {
        // [3]
        key: "campus",
        label: "campus",
        visible: true,
    },
    {
        key: "is_ceo",
        label: "ceo",
        visible: true,
    },
    {
        key: "status",
        label: "status",
        visible: true,
    },
    {
        key: "actions",
        label: "actions",
        visible: true,
    },
]